<template>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="600"
        height="70%"
        
    >
        <v-card>
            <v-card-title style="margin-bottom:15px;">
                {{ 'Classificação do pedido' }}
            </v-card-title>
            <v-card-text v-if="classification && !editMode">
                <p class="question">Classificação escolhida:</p>
                <p><span class="question highlight">{{this.classification}}</span></p>
                <v-divider></v-divider>
                <hr>
                <div class="center-align" style="display:flex; justify-content:space-evenly;"> 
                    <v-btn @click="displayAnswers()">
                        Ver respostas 
                        <v-icon class="btnSpace">mdi-eye</v-icon>
                    </v-btn>
                    <v-btn @click="editClassification()">
                        Alterar classificação
                        <v-icon class="btnSpace">mdi-pencil</v-icon>
                    </v-btn>
                </div>
                <v-row style="margin-top:20px;">
                    <v-card v-if="viewAnswers" class="cardSpace">
                        <v-card v-for="item in this.givenAnswers" class="cardSpace" :key="item.ID">
                            <v-card-title class="question">{{item.PERGUNTA}}</v-card-title>
                            <v-card-text class="question">{{item.RESPOSTA}}</v-card-text>
                        </v-card>
                    </v-card>
                </v-row>
            </v-card-text>
            <v-card-text class="center-align" style="justify-content: center;" v-if="!classification || editMode">
                    <v-progress-circular
                        indeterminate
                        color="grey"
                        v-if="loading"
                        :size="60"
                    ></v-progress-circular>
                    <div
                        v-for="(item, i) in questionnaireComputed"
                        :value="item"
                        color="black"
                        :key="i"
                    >
                        <v-row v-if="item.visible" cols="8">
                            <p class="question" style="font-size:22px; padding:40px;" v-if="unclearResult">
                                Hmmm... Não foi possível concluir uma classificação adequada. Pode ser necessária uma revisão manual.
                            </p>
                        </v-row>

                        <v-row v-if="item.visible" cols="8">
                            <p style=" padding:40px;" class="question">
                                {{item.DESCRICAO}}
                            </p>
                        </v-row>
                        <v-row v-if="item.visible" style=" align-items:center; justify-content:center;">
                            <div v-for="answer in item.answers" :key="answer.ID" style="margin:10px;">
                                <v-btn @click="nextQuestion(item, answer)">
                                    {{answer.DESCRICAO_RESPOSTA}}
                                </v-btn>
                            </div>
                        </v-row>
                    </div>
            </v-card-text>
            <v-card-actions style="justify-content:flex-end;">
                <v-btn color="black" style="color: white;" @click="closeModal()">Cancelar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import pedidoTemClassificacao from '../../../src/app/classificacaoPedido/pedidoTemClassificacao'
import getQuestionnaire from '../../../src/app/classificacaoPedido/getQuestionnaire'

export default {
    name: 'classificationModal',
    props: ['dialog', 'classification', 'serviceId'],
    data(){
        return {
            questionnaire : [],
            givenAnswers : [],
            answers : [],
            unclearResult : false,
            viewAnswers : false,
            editMode : false,
            loading: false
        }
    },
    computed: {
        questionnaireComputed(){
            return !this.loading 
                ? this.questionnaire
                : []
        }
    },
    methods : {
        input(){
            this.$emit('input')
            this.closeModal()
        },
        closeModal(){
            this.returnToInitialState()
            this.$emit('close')
        }
        ,
        displayAnswers(){
            this.viewAnswers = !this.viewAnswers
        },
        editClassification(){
            this.editMode = true
        },
        async getQuestionnaire(){
            this.loading = true
            await getQuestionnaire().then(response => {
                this.questionnaire = response.data
                this.loading = false
            })
        },
        nextQuestion(item, answer){
            this.answers.push(answer)
            this.questionnaire.forEach(q => {
                if(q.ID == answer.CLASSIF_SERV_PERG_ID_PROX_PERG) q.visible = true
            })
            if(!answer.CLASSIF_SERV_PERG_ID_PROX_PERG && answer.SERVICO_CLASSIFICACAO_ID) this.saveClassification(answer)
            if(!answer.CLASSIF_SERV_PERG_ID_PROX_PERG && !answer.SERVICO_CLASSIFICACAO_ID) this.unclearResult = true
            item.visible = false
        },
        returnToInitialState(){
            this.questionnaire.forEach(q => {
                if(q.CODIGO == 1) q.visible = true
                else q.visible = false
            })
            this.answers = []
            this.unclearResult = false
        },
        saveClassification(answer){
            this.$emit("save", {id: answer.SERVICO_CLASSIFICACAO_ID, answers: this.answers })
        },
        async getGivenAnswers(){
            await pedidoTemClassificacao({serviceId : this.serviceId}).then(response => {
                this.givenAnswers = response.data
            })
        }
    },
    async created(){
        if(this.classification) await this.getGivenAnswers()
        await this.getQuestionnaire()
    }
}
</script>
<style scoped>

.question{
    font: 'Baloo 2';
    text-align: center;
    font-size: 22px;
    width:100%;
}
.highlight{
    font-weight:bold;
}
.center-align{
    justify-content: center;
    margin-top:15px;
}
.cardSpace{
    margin-top:10px;
    padding:10px;
}
.btnSpace{
    margin-left:5px;
}
</style>
